export const AuthLoadingComponent = () => {
    return <h3>Authentication in progress...</h3>;
}